import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useNetworkErrorReporter } from 'shared';
import { toastError, toastSuccess } from 'utils';
import WizardFooter from './WizardFooter';
import WizardHeader from './WizardHeader';
function WizardLayout({ children }) {
    useNetworkErrorReporter({ toastError, toastSuccess });
    return (_jsxs("div", { children: [_jsx(WizardHeader, {}), children, _jsx(WizardFooter, {})] }));
}
function mapStateToProps() {
    return {};
}
const mapDispatchToProps = {};
export default compose(connect(mapStateToProps, mapDispatchToProps))(WizardLayout);
